import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { LegalMarkdown } from "@/components/LegalMarkdown";
import { LEGAL_VERSION, LEGAL_EFFECTIVE_DATE } from "@/data/legal";
import { legalContent } from "@/data/legalContent";

export default function ManageData() {
  return (
    <main className="min-h-screen" data-testid="manage-data-page">
      <Nav />
      <article className="mx-auto max-w-3xl px-6 pb-24 pt-36 sm:pt-44">
        <Reveal>
          <Link
            to="/legal"
            className="label-tech inline-flex items-center gap-2 text-neutral-400 transition-colors duration-300 hover:text-white"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Legal Center
          </Link>
          <h1 className="mt-8 font-display text-4xl font-black tracking-tighter text-white sm:text-6xl" data-testid="legal-doc-title">
            Manage &amp; Delete Your Data
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-neutral-400">
            See, export, and permanently delete your JomKonvoi data.
          </p>
          <div className="mt-5 flex flex-wrap gap-3" data-testid="legal-doc-meta">
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono-plex text-xs text-neutral-300">
              Version {LEGAL_VERSION}
            </span>
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono-plex text-xs text-neutral-300">
              Effective {LEGAL_EFFECTIVE_DATE}
            </span>
          </div>
        </Reveal>

        <Reveal className="mt-4">
          <div data-testid="legal-doc-content">
            <LegalMarkdown content={legalContent["data-deletion"]} />
          </div>
        </Reveal>
      </article>
      <Footer />
    </main>
  );
}
